import { FormHelperTextProps } from '@mui/material';

import { StyledFormHelperText } from './styles';

export type THelperText = FormHelperTextProps;

export const HelperText = ({ children, id, ...otherProps }: THelperText) => {
  if (!children) return null;
  return (
    <StyledFormHelperText id={id} {...otherProps}>
      {children}
    </StyledFormHelperText>
  );
};
